import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "SL_newNeed_" }
const _hoisted_2 = { class: "SL_newNeed_l" }
const _hoisted_3 = { class: "SL_newNeed_l_time" }
const _hoisted_4 = {
  key: 0,
  class: "SL_nLt_zmz"
}
const _hoisted_5 = {
  key: 1,
  class: "SL_nLt_dqd"
}
const _hoisted_6 = {
  key: 2,
  class: "SL_nLt_yqd"
}
const _hoisted_7 = {
  key: 3,
  class: "SL_nLt_yqd"
}
const _hoisted_8 = {
  key: 4,
  class: "SL_nLt_yqd"
}
const _hoisted_9 = { class: "SL_newNeed_l_work" }
const _hoisted_10 = { class: "SL_newNeed_r" }
const _hoisted_11 = { class: "SL_newNeed_r_futurePrices" }
const _hoisted_12 = { class: "SL_newNeed_r_appliedNumber" }

import { ref, reactive } from "vue";
import com_date from "@/assets/js/common.js";


export default /*@__PURE__*/_defineComponent({
  __name: 'moduleNewNeed',
  props: {
  item: { type: Object, default: "" },
},
  setup(__props) {

const yyy = __props;
// console.log(yyy);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("view", _hoisted_1, [
    _createElementVNode("view", _hoisted_2, [
      _createElementVNode("view", _hoisted_3, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(__props.item.projectName) + " ", 1),
          (__props.item.state === 1)
            ? (_openBlock(), _createElementBlock("text", _hoisted_4, "招募中"))
            : (__props.item.state === 2)
              ? (_openBlock(), _createElementBlock("text", _hoisted_5, "待签单"))
              : (__props.item.state === 3)
                ? (_openBlock(), _createElementBlock("text", _hoisted_6, "已签单"))
                : (__props.item.state === 4)
                  ? (_openBlock(), _createElementBlock("text", _hoisted_7, "已合作"))
                  : (__props.item.state === 5 || __props.item.state === 7)
                    ? (_openBlock(), _createElementBlock("text", _hoisted_8, "已完成"))
                    : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("view", _hoisted_9, [
        _createElementVNode("view", null, [
          _cache[0] || (_cache[0] = _createTextVNode(" 工作地点： ")),
          _createElementVNode("span", null, _toDisplayString(__props.item.workPlace ? __props.item.workPlace : "暂无"), 1)
        ]),
        _createElementVNode("view", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" 交付时间：")),
          _createElementVNode("span", null, _toDisplayString(_unref(com_date).com_date.timestamp_string(
                __props.item.deliveryTime,
                false,
                "-",
                ":"
              )), 1)
        ]),
        _createElementVNode("view", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" 发布人： ")),
          _createElementVNode("span", null, _toDisplayString(__props.item.nickName), 1)
        ]),
        _createElementVNode("view", null, [
          _cache[3] || (_cache[3] = _createTextVNode(" 技能类型： ")),
          _createElementVNode("span", null, _toDisplayString(__props.item.skillType ? __props.item.skillType : "暂无"), 1)
        ])
      ])
    ]),
    _createElementVNode("view", _hoisted_10, [
      _createElementVNode("view", _hoisted_11, [
        _cache[4] || (_cache[4] = _createTextVNode(" 预估价： ")),
        _createElementVNode("span", null, "￥" + _toDisplayString((__props.item.price / 1).toFixed(2)), 1)
      ]),
      _createElementVNode("view", _hoisted_12, [
        _cache[5] || (_cache[5] = _createTextVNode(" 已报名：")),
        _createElementVNode("span", null, _toDisplayString(__props.item.signUpNum) + "人", 1)
      ])
    ])
  ]))
}
}

})